<template>
    <v-form ref="form" v-model="valid">
    <v-container>
        <v-row no-gutters>
            <v-col cols="6">
                <NumericField dense outlined
                    v-model="c_data.drift"
                    :rules="[rules.mandatory]"
                    label="deriva primario"
                    :readonly="preview"
                ></NumericField>    
            </v-col>
            <v-col cols="4" class="pl-2">
                <NumericField dense outlined
                    v-model="c_data.uniformity"
                    :rules="[rules.mandatory]"
                    label="uniformità primario"
                    :readonly="preview"
                ></NumericField>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="font-weight-bold">Interpolazione</div> 
                <div class="pl-2 my-1" v-katex:display="tex_equation_error"/>
            </v-col>
            <v-col cols="3">
                <NumericField dense outlined
                    v-model="c_data.a"
                    :rules="[rules.mandatory]"
                    label="termine noto"
                    :readonly="preview"
                    :negative="true"
                ></NumericField>
                
            </v-col>
            <v-col cols="3" class="pl-2">
                <NumericField dense outlined
                    v-model="c_data.b"
                    :rules="[rules.mandatory]"
                    label="primo grado"
                    :readonly="preview"
                    :negative="true"
                ></NumericField>
            </v-col>
            <v-col cols="3" class="pl-2">
                <NumericField dense outlined
                    v-model="c_data.c"
                    :rules="[rules.mandatory]"
                    label="secondo grado"
                    :readonly="preview"
                    :negative="true"
                ></NumericField>
            </v-col>
            <v-col cols="3" class="pl-2">
                <NumericField dense outlined
                    v-model="c_data.d"
                    :rules="[rules.mandatory]"
                    label="terzo grado"
                    :readonly="preview"
                    :negative="true"
                ></NumericField>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="font-weight-bold">Interpolazione</div>
                <div class="pl-2 my-1" v-katex:display="tex_equation_U"/>
            </v-col>
            <v-col cols="3">
                <NumericField dense outlined
                    v-model="c_data.a_U"
                    :rules="[rules.mandatory]"
                    label="termine noto"
                    :readonly="preview"
                    :negative="true"
                ></NumericField>
            </v-col>
            <v-col cols="3" class="pl-2">
                <NumericField dense outlined
                    v-model="c_data.b_U"
                    :rules="[rules.mandatory]"
                    label="primo grado"
                    :readonly="preview"
                    :negative="true"
                ></NumericField>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <v-simple-table dense class="measure_table">
                    <template v-slot:default>
                        <thead class="expansion">
                        <tr>
                            <th class="table-text-blocks text-right align-center" v-for="head of compHeaders" :key="head.value">{{head.text}}</th>
                        </tr>
                    </thead>
                    <tr v-for="(o_val,idx) of c_data.values" :key="idx">
                        <td v-for="head of compHeaders" :key="head.value" class="table-blocks">
                            <NumericField dense outlined
                                hide-details
                                v-model="o_val[head.value]"
                                :rules="[rules.mandatory]"
                                :readonly="preview"
                                :negative="true"
                            ></NumericField>
                        </td>
                        <td v-if="!preview">
                            <v-btn color="action" fab small @click.stop="deleteRow(o_val, idx)"><v-icon>delete</v-icon></v-btn>
                        </td>
                    </tr>
                </template>       
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row v-if="!preview" no-gutters>
            <v-col cols="12" class="d-flex justify-end my-3">
                <!-- <VueUploadComponent
                input-id="file2"
                ref="up_csv"
                v-model="csvfiles"
                @input-file="processFile"
                @input-filter="inputFilter"
                class="btn"
                >
                    <v-btn color="action"><v-icon>import_export</v-icon>Importa da CSV</v-btn>
                </VueUploadComponent> -->
                <v-btn color="action" @click="addRow" class="ml-2"><v-icon>add_box</v-icon>Aggiungi punto</v-btn>
            </v-col>
        </v-row>
    </v-container>
    </v-form>
</template>
<script>
const nerdamer = require('nerdamer/all');
import VueUploadComponent from "vue-upload-component";
import {getModel} from "../utils/model"
import {f_rules} from '../utils/commonUtils'
// import _ from 'lodash'

export default {
    components: {VueUploadComponent},
    props: {
        'data':{
            type: Object,
            required: true
        }, 
        'preview': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            c_data: null,
            items: [],
            valid: false,
            rules: f_rules,
            csvfiles: [],
            title: 'Dati specifici fornetto calibratore',
            pagination: {'rowsPerPage': -1},
            equation: "a + bx + cx^2 + dx^3",
            equation_U: "a + bx",
            tex_equation_error: "0",
            tex_equation_U: "0"
        }
    },
    beforeMount() {
        if(this.data && this.data.block && this.data.block.model){
            if (_.isEmpty(this.data.p_data)){
                let Model = getModel(this.data.block.model)
                this.c_data = Model()
            } else {
                this.c_data = _.cloneDeep(this.data.p_data)
            }
        } else {
            console.log("debug: error", this.data)
        }
        this.tex_equation_error = "Errore: " + nerdamer.convertToLaTeX(this.equation); // TODO: check spaces in katex
        this.tex_equation_U = "Incertezza:" + nerdamer.convertToLaTeX(this.equation_U) 
    },
    computed: {
        compHeaders(){
            console.log("debug: building headers")
            let dictionary = this.c_data.header
            var values = Object.keys(dictionary).map(function(key){
                return {text: dictionary[key], value: key}
            });
            console.log("debug: headers value", values )
            return values
        }
    },
    methods: {
        addRow(){
            let dictionary = {}
            for(let key of Object.keys(this.c_data.header)){
                dictionary[key] = null
            }
            this.c_data.values.push(dictionary)
        },
        deleteRow(item){
            let n = this.c_data.values.indexOf(item)
            console.log("valore trovato:", n)
            this.c_data.values.splice(n,1)
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-csv file
                if (!/\.(csv)$/i.test(newFile.name)) {
                return prevent()
                }
            }
        },
        // processFile(){
        //     console.log("test file input", this.csvfiles[0])
        //     this.$papa.parse(this.csvfiles[0].file, {header: true, skipEmptyLines: 'greedy', complete: (results) => {
        //         this.items = results.data
        //         let testillo = results.data[0]
        //         console.log("results parsing", this.items)
        //         // let cose = this.$papa.unparse(results)
        //         // console.log("tentativo 2", cose)
        //         // this.download("esempio.csv", cose)
        //     }})
        // },
        getData() {
            return this.c_data
        }
    },
    watch: {
        'valid':{
            handler() {
                this.$parent.$emit('validitySpecific', this.valid)
            }
        }
    },
}
</script>

<style lang="scss">
    .katex-display > .katex {
        text-align: left;
    }
</style>